var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRetryGreen(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12,
    height: 14,
    viewBox: "0 0 12 14",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_13427",
    "data-name": "Path 13427",
    d: "M8.579,11.958a.734.734,0,0,0,1.007.265h0a.783.783,0,0,0,.241-1.06,4.814,4.814,0,0,1-.638-2.916,4.644,4.644,0,0,1,4.2-4.227,4.6,4.6,0,0,1,4.836,4.728A4.65,4.65,0,0,1,13.784,13.4h-.028V12.282a.4.4,0,0,0-.61-.353l-2.907,1.9a.422.422,0,0,0,0,.707l2.893,1.885a.4.4,0,0,0,.61-.353V14.933a6.145,6.145,0,0,0,5.942-6.7A6.16,6.16,0,0,0,14.153,2.5,6.112,6.112,0,0,0,7.7,8.717,6.419,6.419,0,0,0,8.579,11.958Z",
    transform: "translate(-7.7 -2.485)",
    fill: "#00bb25"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRetryGreen);
export default __webpack_public_path__ + "static/media/retryGreen.31e49f9f1a311591d380d24f28f80c49.svg";
export { ForwardRef as ReactComponent };